// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"4c2488d9","181":"b0ed8f57","299":"1d53790b","457":"d5dfd4cc"}[chunkId] + ".chunk.css";
};